import { PaymentModuleId } from '@foundation/apis/payments';

import { registerStartupable } from '@/services/base/StartupHelper';

import { OptionalStartupable } from '../base/Startupable';
import { paymentInstrumentAuthorize } from '../payments/intent/PaymentIntentApi';
import PaymentStore from '../payments/PaymentStore';

class PaymentOnDeliveryService implements OptionalStartupable {
  public readonly name = 'PaymentOnDeliveryService';
  public readonly moduleId = PaymentModuleId.PaymentOnDelivery;

  constructor() {
    registerStartupable(this, [PaymentStore]);
  }

  public startup(): Promise<void> {
    return Promise.resolve();
  }

  public shouldStart(): boolean {
    return PaymentStore.allowedPaymentModules.includes(this.moduleId);
  }

  public authorise(accessToken: string) {
    return paymentInstrumentAuthorize(
      {
        paymentIntentId: PaymentStore.paymentIntentId,
        paymentDataTypeId: this.moduleId,
      },
      accessToken,
    );
  }
}

export default new PaymentOnDeliveryService();
